module.exports = __webpack_public_path__ + "img/goods2_7.3a1975f5.jpg";